<template>
  <div>Forbidden...</div>
</template>

<script>
export default {
  created() {
    if (process.env.NODE_ENV === 'development') {
      this.$store.commit('setToken', '132e2805407a50bbd27a10dccefe0d55');
      this.$store.commit('setGatewaysToken', '132e2805407a50bbd27a10dccefe0d55');
      this.$router.push({name: 'map', params: { id: '74aaf2ea-f8aa-4ace-8b6f-1670243fcc10' }});
    }
  }
}
</script>